
































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { Sheet } from "../../modules/digital_paper/SheetList"

export interface Data {
  sheets: Sheet[]
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheets: [],
      errors: [],
    });

    /************************************************************
     * 採点結果PDF表示
     ************************************************************/

    const downloadResultPdf = async (sheet_id: number, student_no: number) => {

      if(context.root.$store.state.isMobile){
        const button = document.getElementById("link-question");
        if(button){
          button.click();
        }
      }else{
        context.root.$store.dispatch("showOverlay");
      
        await http.get(`/api/digital_paper/sheet_list/download_result_pdf/${sheet_id}/${student_no}`, {responseType: 'arraybuffer'}).then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.target = "_blank"
          a.click();
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });

        context.root.$store.dispatch("hideOverlay");
      }
    }

    /******************************
     * 採点結果表示画面へ
     ******************************/

    const toResultImagePreview = async (sheet: any) => {
      if(context.root.$store.state.currentUser.role == Common.RoleEnum.DigitalPaper){
        context.root.$router.push(`/digital_paper_site/result_image_preview/${sheet.id}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/result_image_preview/${sheet.id}`).catch(err => {});
      }
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/digital_paper/sheet_list?email=${context.root.$store.state.digitalPaperEmail}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      downloadResultPdf,
      toResultImagePreview,
    }
  }
});
